import styled from "styled-components";

export const ContractsContentStyled = styled.div`
    .titlePageContainer {
        text-align: center;
        margin-bottom: 16px;
    }

    .uploadCard {
        border: 1px solid #b3b3b38c;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 24px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .uploadRow {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
    }

    .fileName {
        font-size: 0.9rem;
        color: #555;
    }

    .contractList {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 32px;
    }

    .contractCard {
        border: 1px solid #b3b3b38c;
        border-radius: 8px;
        padding: 14px 16px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        flex-wrap: wrap;
        background: #fafafa;
    }

    .contractInfo {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 240px;
        flex: 1;
    }

    .contractCard.current {
        border-color: var(--primary);
        background: #edf4ff;
    }

    .currentBadge {
        display: inline-flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 4px;
    }

    .signatoriesList {
        margin: 4px 0 0;
        padding-left: 18px;
        font-size: 0.82rem;
        color: #555;
    }

    .signatoriesList li {
        margin-bottom: 2px;
    }

    .contractName {
        font-weight: 700;
        font-size: 0.95rem;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .contractMeta {
        font-size: 0.82rem;
        color: #555;
    }

    .contractActions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
    }

    .emptyState {
        padding: 16px;
        color: #666;
        text-align: center;
    }

    .logsTitle {
        margin-bottom: 10px;
    }

    .logsList {
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 320px;
        overflow-y: auto;
        border: 1px solid #b3b3b38c;
        border-radius: 8px;
        padding: 12px;
        background: #f7f7f7;
    }

    .logItem {
        font-size: 0.85rem;
        padding-bottom: 8px;
        border-bottom: 1px dotted #cfcfcf;
    }

    .logItem:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .logDate {
        font-weight: 700;
        margin-right: 6px;
    }

    .hiddenInput {
        display: none;
    }

    @media (max-width: 700px) {
        .contractCard {
            flex-direction: column;
        }

        .uploadRow {
            flex-direction: column;
            align-items: stretch;
        }
    }
`;
